import { Reducer } from "redux";
import { Action, ActionType } from "../../../actions";
import { SSRTableData } from "../../../state/BookingCreateManagerV2/SSR/TableData";

const updateSSRTableData: Reducer<SSRTableData> = (
  state: SSRTableData = new SSRTableData(),
  action: Action<ActionType, SSRTableData>
) => {
  switch (action.type) {
    case ActionType.BOOKING_CREATE_MANAGER_V2_SSR_TABLE_DATA_FETCHED:
      return {
        ...state,
        records: action.data.items,
        totalItems: action.data.totalItems,
      };
    case ActionType.BOOKING_CREATE_MANAGER_V2_SSR_TABLE_DATA_ROW_DELETED:
      let newRuleList = state.records.filter(
        (item) => item.id !== action.data.id
      );
      return { ...state, records: newRuleList };
    default:
      return state;
  }
};

export default updateSSRTableData;
